import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { apiKey } from "../../../config/config";
import handleCSRF from "../../../config/CSRF";
import { toast } from "react-toastify";

function AddVendorForm() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const { id } = useParams();
  const [formData, setFormData] = useState({
    vendor_name: "",
    description: "",
    user_id: user?.user.id,
    phone: "",
    outlet_id: user?.user.outlet_id,
  });

  const [loading, setLoading] = useState(false);
  // const [pageLoading, setPageLoading] = useState(false);
  // const [error, setErrorr] = useState(false);
  const [formErrors, setFormErrors] = useState({
    vendor_name: "",
    description: "",
    phone: "",
  });

  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    // Clear error message when user starts typing again
    setFormErrors({
      ...formErrors,
      [e.target.name]: "",
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Regular expression to allow only letters and spaces
    // const alphaRegex = /^[a-zA-Z\s]+$/;

    // // Basic validation
    // let errors = {};
    // if (!formData.vendor_name.trim()) {
    //   errors.vendor_name = "Vendor name is required";
    // } else if (!alphaRegex.test(formData.vendor_name)) {
    //   errors.vendor_name = "Vendor name must contain only letters and spaces";
    // }

    // if (!formData.description.trim()) {
    //   errors.description = "Description is required";
    // } else if (typeof formData.description !== "string") {
    //   errors.description = "Description must be a string";
    // }

    // if (!formData.phone.trim()) {
    //   errors.phone = "Phone is required";
    // } else if (isNaN(formData.phone)) {
    //   errors.phone = "Phone must be a number";
    // }

    // if (Object.keys(errors).length > 0) {
    //   setFormErrors(errors);
    //   return; // Exit if there are validation errors
    // }

    // setLoading(true);
    const postData = () => {
      if (!id) {
        axios
          .post(`${apiKey}/api/rms/admin/vendor`, formData, {
            headers: {
              Authorization: `Bearer ${user?.token}`,
            },
          })
          .then((res) => {
            toast.success("Vendor added successfully", {
              position: "bottom-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            navigate(-1);
          })
          .catch((err) => {
            Object.keys(err.response.data.data).forEach((item) => {
              err.response.data.data[item].forEach((i) => {
                toast.error(i || "Validation Error");
              });
            });
          });
        // .finally(() => setLoading(false));
      } else {
        axios
          .put(`${apiKey}/api/rms/admin/vendor/${id}`, formData, {
            headers: {
              Authorization: `Bearer ${user?.token}`,
            },
          })
          .then((res) => {
            toast.success("Vendor updated successfully", {
              position: "bottom-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            navigate(-1);
          })
          .catch((err) => {
            Object.keys(err.response.data.data).forEach((item) => {
              err.response.data.data[item].forEach((i) => {
                toast.error(i || "Validation Error");
              });
            });
          })
          .finally(() => setLoading(false));
      }
    };
    handleCSRF(postData);
  };

  useEffect(() => {
    if (id) {
      // setPageLoading(true);
      axios
        .get(`${apiKey}/api/rms/admin/vendor/${id}`, {
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
        })
        .then((res) => {
          setFormData(res.data);
        })
        .catch((err) => {
          toast.error(err.response.data.message, {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        })
        .finally(() => setLoading(false));
    }
  }, [id, user?.token]);

  return (
    <main>
      <div className="relative my-16 flex flex-col min-w-0 break-words w-full mb-6 shadow-lg bg-white rounded-lg p-4 border-0">
        <div className="flex justify-between items-center mb-4">
          <h1 className="text-d-bg-text text-2xl"> Add Vendor</h1>
        </div>
        <div className="w-full">
          <form action="" className="w-full" onSubmit={handleSubmit}>
            <div className="flex flex-col md:flex-row gap-x-8 gap-y-2 w-full">
              <label htmlFor="" className="w-full">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                  Vendor Name
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder="Vendor name"
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    required
                    name="vendor_name"
                    value={formData.vendor_name}
                    onChange={handleChange}
                  />
                  {formErrors.vendor_name && (
                    <span className="text-red-500 text-xs mt-1">
                      {formErrors.vendor_name}
                    </span>
                  )}
                </div>
              </label>

              <label htmlFor="" className="w-full">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                  Description
                </span>
                <div className="mb-2 pt-0">
                  <textarea
                    rows="3"
                    placeholder="Enter..."
                    className=" px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full "
                    required
                    name="description"
                    value={formData.description}
                    onChange={handleChange}
                  />
                  {formErrors.description && (
                    <span className="text-red-500 text-xs mt-1">
                      {formErrors.description}
                    </span>
                  )}
                </div>
              </label>
            </div>

            <div className="flex flex-col md:flex-row gap-y-2 w-full">
              <label htmlFor="" className="w-full md:w-2/4">
                <span className="text-d-bg-text text-sm mb-2 -mt-4 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                  Phone
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder="Phone"
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    required
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                  />
                  {formErrors.phone && (
                    <span className="text-red-500 text-xs mt-1">
                      {formErrors.phone}
                    </span>
                  )}
                </div>
              </label>
            </div>

            <span className="w-full bg-d-bg h-1 my-2 inline-block"></span>
            <div className="flex gap-2">
              <button
                className="bg-d-cat-btn text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit relative"
                type="submit"
              >
                {loading && (
                  <span className="absolute top-0 left-0 w-full h-full py-1 px-3 bg-black bg-opacity-50">
                    <img
                      className="w-4 mx-auto"
                      src="/assets/gif/button_loader.gif"
                      alt=""
                    />
                  </span>
                )}
                Submit
              </button>
              <button
                className="bg-d-cat-btn text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
                type="button"
                onClick={() => navigate(-1)}
              >
                Back
              </button>
            </div>
          </form>
        </div>
      </div>
    </main>
  );
}

export default AddVendorForm;
